<template>
    <div class="x-input x-input-quantity" :class="{'x-input-error': !!error}">
        <label class="x-label" :class="labelClass" v-if="!!label">{{ label }}
            <slot name="label"></slot>
            <el-tooltip :content="tooltipContent"
                        effect="dark"
                        placement="top-end"
                        v-if="!!tooltipContent">
                <i class="fa fa-info-circle"></i>
            </el-tooltip>
        </label>
        <el-input :class="{'x-input-readonly': readonly}"
                  :value="value"
                  @input="handleInput($event)"
                  @focus="$emit('focus', $event)"
                  :type="type" :name="name" :readonly="readonly">
            <template slot="prepend">
                <x-button-icon icon="fa-light fa-minus"
                               @click="clickDecrease">
                </x-button-icon>
            </template>
            <template slot="append">
                <x-button-icon icon="fa-light fa-plus"
                               @click="clickIncrease">
                </x-button-icon>
            </template>
        </el-input>
        <small v-if="textError !== ''" class="x-label-error" v-text="textError"></small>
    </div>
</template>

<script>
import XButtonIcon from "./XButtonIcon.vue";

export default {
    name: 'XInputQuantity',
    components: {XButtonIcon},
    props: {
        value: {
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        label: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: '',
        },
        error: {
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        tooltipContent: {
            type: String,
            default: null,
        },
        labelClass: {
            type: String,
            default: null,
        },
        step: {
            default: 1
        }
    },
    data() {
        return {}
    },
    computed: {
        textError() {
            if (!_.isNull(this.error)) {
                return this.error[0];
            }
            return '';
        }
    },
    methods: {
        handleInput(value) {
            if (isNaN(Number(value)) || parseFloat(value) === 0) {
                value = parseFloat(this.step);
            }
            this.$emit('input', value)
        },
        clickDecrease() {
            let val = _.round(parseFloat(this.value) - parseFloat(this.step), this.getDecimalLength());
            if (val === 0) val = parseFloat(this.step);
            this.$emit('input', val)
        },
        clickIncrease() {
            let val = _.round(parseFloat(this.value) + parseFloat(this.step), this.getDecimalLength());
            this.$emit('input', val)
        },
        getDecimalLength() {
            let dec = String(this.step).split(".");
            return dec.pop().length;
        }
    }
}
</script>
